<!--
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-05-25 19:05:44
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-04-29 10:57:31
 * @FilePath: \jyrg-web\src\components\mobile\Header\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <header>
    <div class="content">
      <header class="nav">
        <div class="nav-left">
          <div class="header-icon">
            <img src="../../../assets/image/mb/logo-mb.png" alt />
          </div>
          <div class="header-info">
            <span>群侠传</span>
            <span>Q版千年</span>
            <!-- <span>群雄逐鹿 &nbsp; 侠肝义胆</span> -->
          </div>
        </div>
        <div class="nav-right">
          <!-- 官网1.0取消登录按钮 -->
          <div class="r-item">欢迎您,{{ userInfo }}</div>
          <div class="r-item" v-if="userInfo == '****'" @click="login">登录</div>
          <div class="r-item" v-else @click="loginOut()">注销</div>
          <div class="download">
            <!-- 官网1.0 暂不开启下载 -->
            <a :href="url" style="color:#fbf7c7;">下载游戏</a>
            <!-- <a @click="message()">下载游戏</a> -->
          </div>
        </div>
             <!-- 汉堡按钮 -->
             <button class="hamburger" @click="toggleMenu" v-show="this.isMenuButton">
          </button>
          <button class="hamburger" @click="toggleMenuTwo" v-show="this.isMenuButtonTwo">
          </button>
      <!-- 遮罩层 -->
    <div class="menu-mask" 
         v-show="isMenuOpen" 
         @click="closeMenu"></div>
    <!-- 主菜单 -->
    <div class="menu-content"   v-show="this.isMenuOpen">
      <ul class="main-menu">
        <li v-for="(item, index) in menuData" :key="index">
            <div class="menu-item"  @click="navSkip(item)" >
          {{ item.name }}

          </div>
        </li>
      </ul>
       </div>
      </header>
    </div>
  </header>
</template>

<script>
import { Dialog } from "vant";
import { mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      url: "",
      downloadUrls: {},
      isMenuButton: true,
      isMenuButtonTwo: false,
      isMenuOpen: false,
      menuData: [
 
          { name: "首页", type: "parent",   isOpen: false,id: 0 },

          { name: "公告咨询", type: "parent",  isOpen: false, id: 0 },
          { name: "江湖资料", type: "parent",   isOpen: false,id: 0 },
          { name: "联系我们", type: "parent",   isOpen: false,id: 0 },
          ]
    };
  },
  computed: {
    orderNum() {
      return this.$store.state.base.orderNum;
    },
    userInfo() {
      let info = this.$store.state.user.userInfo;
      info = info ? info : "****";
      return info;
    },
  },
  created() {
    this.downloadUrl();
  },
  methods: {
    ...mapActions({
      Logout: "user/Logout",
      getDownloadUrl: "base/getDownloadUrl",
    }),
    ...mapMutations({
      LOGOUT: "user/LOGOUT",
      loginDialog: "base/loginDialog",
    }),
    message() {
      location.href = location.href + "?time=" + new Date().getTime();
    },
    
    async navSkip(item) {
      let { id, path, type, name: title } = item;
      switch (title) {
        case "首页":
        this.toggleMenuTwo()
          this.$router.push({ path: "/home" });
          break;
          case "联系我们":
          this.toggleMenuTwo()
       this.$router.push({ path: "/detail",query: {id:1,title:'联系我们' }});
          break;
          case "公告咨询":
          this.toggleMenuTwo()
          this.$router.push({ path: "/newspaper" ,query: {title:'公告咨询' }});
          break;
          case "江湖资料":
          this.toggleMenuTwo()
          this.$router.push({ path: "/information",query: {title:'江湖资料' }});
          break;
  
        case "账号充值":
          // 弹窗
          this.voucherCenterarHandle(true);
          break;
        case "官方社区":
          window.open("http://bbs.open1000y.com");
          break;
        // case "联系我们":
        // this.$router.push({ path: "/about",query: {title:'联系我们' }});
        //   this.toggleMenuTwo()
        //   break;

        default: {
          this.toggleMenuTwo()
          this.$router.push({ path: "/detail", query: { id, title} });
          break;
        }
      }
    },
    // 登录
    login() {
      this.loginDialog(true);
    },

    // 登出
    async loginOut() {
      try {
        await Dialog.confirm({
          title: "",
          message: "是否退出登录",
        });
        await this.Logout();
      } catch (error) {
        console.log(error);
      }
    },

    // 下载
    async downloadUrl() {
      let { anxUrl, iosUrl } = await this.getDownloadUrl();
      this.url = this.$utils.isMobileType() == "ios" ? iosUrl : anxUrl;
    },
    toggleMenu() {
      this.isMenuOpen = true
      this.isMenuButtonTwo=true;
      this.isMenuButton=false;
    },
    toggleMenuTwo(){
      this.isMenuOpen = false;
      this.isMenuButton=true;
      this.isMenuButtonTwo=false;
    },
    closeMenu() {
      this.isMenuOpen = false
      // 关闭所有子菜单
      this.menuData.forEach(item => {
        item.isOpen = false
        this.isMenuButton=true;
        this.isMenuButtonTwo=false;
      })
    },
    toggleSubMenu(index) {
      // 关闭其他已打开的子菜单
      this.menuData.forEach((item, i) => {
        if (i !== index) {
          item.isOpen = false
        }
      })
      // 切换当前子菜单状态
      this.menuData[index].isOpen = !this.menuData[index].isOpen
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  position: fixed;
  top: 0;
  left: 0;
  width: 375px;
  height: 34px;
  display: flex;
  justify-content: center;
  z-index: 1000;
  .nav {
    padding: 0 10px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: url("../../../assets/image/mb/nav-bg.png");
    background-size: 100% 100%;
    .nav-left {
      display: flex;
      align-items: center;
      .header-icon {
        width: 29px;
        height: 29px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .header-info {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        margin-left: 5px;
        color: #bf956a;
        span:nth-child(1) {
          font-size: 10px;
        }
        span:nth-child(2) {
          font-size: 6px;
        }
      }
    }
    .nav-right {
      display: flex;
      align-items: center;
      .r-item {
        color: #fff;
        width: auto;
        font-size: 14px;
        margin-right: 15px;
        font-family: "字体一";
      }
      .download {
        width: 80px;
        height: 22px;
        text-align: center;
        line-height: 22px;
        font-size: 12px;
        color: #fff;
        font-weight: 600;
        letter-spacing: 2px;
        background: url("~@/assets/image/mb/download.png") no-repeat;
        background-size: 100% 100%;
      }
 
    }
       /* 汉堡按钮样式 */
     .hamburger {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        width:25px;
        height: 20px;
       background: url("~@/assets/image/mb/menu.png") no-repeat;
        background-size: 100% 100%;
        border: none;
        cursor: pointer;
        margin-left: 5px;
        z-index: 10;
      }
     /* 菜单遮罩层 */
     .menu-mask {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: #000;
          opacity: 0.75;
          z-index: 8;
        }

        /* 菜单内容 */
        .menu-content {
          position: fixed;
          top: 39px;
          width:100%;
          // margin-left: 45%;
          // max-width: 300px;
          height:45vh;
          background: #ffffff00;
          // box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
          transition: left 0.3s ease;
          z-index: 9;
          overflow-y: auto;
        }
        .content-log{
             width:55%;
             height: 100px;
             margin: auto;
             margin-top:10px;
             img{
              width: 100%;
              height: 100%;
             }
        }

        .menu-content.active {
          left: 0;
        }

        /* 主菜单样式 */
        .main-menu {
          list-style: none;
          padding: 0;
          margin: 0;
          width: 95%;
        }

        .main-menu > li {
          border-bottom: 1px dashed  #fff;
        }

        .menu-item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px 20px;
    color: #e0e0e0;
    cursor: pointer;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.05);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }

  .menu-item::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
    transition: left 0.6s ease;
  }


        .menu-item:hover {
            color: #fff;
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
            background: rgba(255, 255, 255, 0.1);
          }
        .item-title{
          // width: 97%;
          // height: 50px;
          // text-align: right;
          // line-height: 53px;
        
        }
        .arrow {
          transition: transform 0.3s;
          font-size: 1.2rem;
        }

        .arrow.open {
          transform: rotate(90deg);
        }

        /* 二级菜单样式 */
        .sub-menu {
          list-style: none;
          padding: 0;
          margin: 0;
          background: #0f0e0e99;
          overflow: hidden;
          transition: max-height 0.3s ease;
        }

        .sub-menu li a {
          display: block;
          padding: 0.8rem 1rem 0.8rem 2rem;
          color: #fff;
          text-align: center;
          text-decoration: none;
        }

        .sub-menu li a:hover {
          background: #3d3c3c7e;
        }
  
  }
}
</style>
